import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-charge-weight-slabs',
  templateUrl: './charge-weight-slabs.component.html',
  styleUrls: ['./charge-weight-slabs.component.scss']
})
export class ChargeWeightSlabsComponent {
  @Input() showSlabsModal = false;
  @Input() mappingId: number;

  maxWeight: number;
  isDetailFormSubmitted = false;
  mappingDetailsRowData = [];
  detailId: number;
  isDetailEdit = false;
  detailForm: FormGroup;
  public context: any;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;

  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true
  };

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }
  // useEnterKey: any;

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  calculateTypeOptions = [
    { id: 1, name: 'FLAT' },
    { id: 2, name: 'RANGE' },
  ];

  roundOff = [
    { id: 1, name: '0.100' },
    { id: 2, name: '0.250' },
    { id: 3, name: '0.500' },
    { id: 4, name: '1.000' },
  ];

  mappingDetailsColumnDefs = [
    { headerName: 'Calculation Type', field: 'calculationtype' },
    { headerName: 'Min', field: 'minweight' },
    { headerName: 'Max', field: 'maxweight' },
    { headerName: 'Amount', field: 'amount' },
    { headerName: 'RoundOff', field: 'roundoff' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 80,
      filter: false,
      pinned: 'right',
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private chargesService: ChargesService,
    public activeModal: NgbActiveModal,
    private appCoreService: AppCoreService
  ) {
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    //console.log('init : chargeDetailData', this.chargeDetailData);

    //this.currentDate = this.formateDate().dateString;
    this.detailForm = this.formBuilder.group({
      ddlCalculationType: ['FLAT'],
      txtMin: ['0', Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(?:\.\d{0,3})?$/)])],
      txtMax: [null, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(?:\.\d{0,3})?$/)])],
      txtAmount: [null, Validators.compose([Validators.required, Validators.pattern(/^\d{0,12}(?:\.\d{0,3})?$/)])],
      ddlRoundOff: []
    });
    if (this.mappingId) {
      this.bindMappingDetails();
    }
    // const userData = this.appCoreService.GetUserData();
    // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  editAction(cell: any) {
    try {
      if (cell && cell.id) {
        this.getDetail(cell);
      }
    } catch (e) {
      console.error(e);
    }
  }

  deleteAction(cell: any) {
    if (cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell);
    }
  }

  getDetail(data: any) {
    this.detailId = data.id;
    this.isDetailEdit = true;
    this.detailForm.patchValue({
      ddlCalculationType: data.calculationtype,
      txtMin: data.minweight,
      txtMax: data.maxweight,
      txtAmount: data.amount,
      ddlRoundOff: data.roundoff
    });
  }

  upsertDetail() {
    this.isDetailFormSubmitted = true;
    const min = parseInt(this.detailForm.get('txtMin').value);
    const max = parseInt(this.detailForm.get('txtMax').value);
    if (min > max) {
      this.appCoreService.showMessage('Max Weight should be greater than Min Weight.', 'Warning', 'warning')
      return;
    }
    // if (!this.mappingId) {
    //   this.showWarningNotification('mapping Id does not exists!!! ');
    //   return;
    // }
    if (this.detailForm.valid) {
      const reqObj = {
        id: this.detailId,
        mappingid: this.mappingId,
        calculationtype: this.detailForm.get('ddlCalculationType').value,
        minweight: this.detailForm.get('txtMin').value,
        maxweight: this.detailForm.get('txtMax').value,
        amount: this.detailForm.get('txtAmount').value,
        roundoff: this.detailForm.get('ddlRoundOff').value
      }
      if (this.isDetailEdit) {
        this.ngxLoaderService.start();
        this.chargesService.UpdateDetails(reqObj).subscribe((res) => {
          if (res && res.success) {
            this.bindMappingDetails();
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record Updated Successfully!', 'Success', 'success');
            // this.activeModal.close('Save Click');
            this.resetDetailForm();
          }
          else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Warning', 'warning');
          }
        });
        this.ngxLoaderService.stop();
      }
      else {
        this.ngxLoaderService.start();
        this.chargesService.AddDetails(reqObj).subscribe((res) => {
          if (res && res.success) {
            this.bindMappingDetails();
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record Added Successfully!', 'Success', 'success');
            this.resetDetailForm();
          }
          else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Warning', 'warning');
          }
        });
        this.ngxLoaderService.stop();
      }
    }
  }

  bindMappingDetails() {
    this.ngxLoaderService.start();
    this.chargesService.GetDetailsById(this.mappingId).subscribe((res) => {
      if (res && res.success) {
        this.mappingDetailsRowData = res.data || [];
        const data = this.mappingDetailsRowData ? this.mappingDetailsRowData[this.mappingDetailsRowData.length - 1] : {};
        this.maxWeight = data?.maxweight;
        this.detailForm.get('txtMin').setValue(this.maxWeight || '0');
        this.ngxLoaderService.stop();
      }
    })
  }

  deleteDetaillsRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.chargesService.DeleteDetails(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindMappingDetails();
          }
        });
        this.ngxLoaderService.stop();
      }
    } catch (e) {
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any, data?: any) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      this.deleteDetaillsRecord(data.id);
    }
  }

  resetDetailForm() {
    this.detailForm.reset();
    this.isDetailEdit = false;
    this.isDetailFormSubmitted = false;
    this.detailId = null;
    this.detailForm.get('ddlCalculationType').setValue('FLAT');
    this.detailForm.get('txtMin').setValue(this.maxWeight);
  }

}